export default "__VITE_ASSET__WbYu8Gv5__"